//src/app/features/profile/business/BusinessCard.tsx
import { IClientBusiness } from 'app/services/responseTypes';
import { EditIcon } from 'assets/icons';
import Button from 'Components/Buttons/Button';
import { USDate } from 'Components/Dates/USDate';
import UserAvatarList from 'Components/UserAvatarList';
import { useNavigate } from 'react-router-dom';
import { BusinessLogo } from '../businessDetails/previewBusinessDetails';

export default function BusinessCard({
  value: b,
  canEdit = true,
}: {
  value: IClientBusiness;
  canEdit?: boolean;
}) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(`${b.id}`)}
      className={`hover:bg-[#fbfbfb]  rounded-md cursor-pointer shadow-md grid gap-2`}
    >
      <div className="flex gap-4 items-center p-2">
        <div>
          <BusinessLogo
            disabled={true}
            businessId={b.id}
            logo_url={b.logo_url}
          />
        </div>

        <div className="grid gap-2">
          <div className="flex w-full text-gray-dark font-bold">{b.name}</div>
          <USDate className="text-sm text-gray-light" date={b.created_at} />

          {b.subscribed?.TAX ? (
            <span
              className="text-xs font-semibold"
              style={{ color: '#16a34a', lineHeight: '1' }}
            >
              Tax Subscribed
            </span>
          ) : (
            <span
              className="text-xs font-semibold"
              style={{ color: '#dc2626', lineHeight: '1' }}
            >
              Tax Fit & File
            </span>
          )}

          {b.subscribed?.BK ? (
            <span
              className="text-xs font-semibold"
              style={{ color: '#16a34a', lineHeight: '1' }}
            >
              Bookkeeping Subscribed
            </span>
          ) : (
            <span
              className="text-xs font-semibold"
              style={{ color: '#dc2626', lineHeight: '1' }}
            >
              Bookkeeping Not Subscribed
            </span>
          )}
        </div>
      </div>

      <div className="flex justify-between items-center border-gray-100 p-2">
        {b.team_members.length > 0 && (
          <UserAvatarList size="sm" users={b.team_members} />
        )}
        {!b.team_members.length && (
          <div className="text-gray-light/50 text-xs">Not Assigned Yet</div>
        )}

        {canEdit && (
          <Button
            className="max-w-min ml-auto self-end"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`${b.id}/edit`);
            }}
          >
            <EditIcon className="text-gray-700 w-4 h-4" />
          </Button>
        )}
      </div>
    </div>
  );
}
